import { API_BASE_URL } from "@/config";
import { validateToken } from '@/utils/auth';
import CustomTabs from '@/components/CustomTab/CustomTab.vue';
import Swal from 'sweetalert2';
import $ from 'jquery';
import { TERMS_CONDITIONS_TEMPLATE } from '@/utils/constants.js';
import { useToast } from "@/components/Toast/useToast";

export default {
  name: 'ApplicationComponent',
  components: {
    CustomTabs
  },

  setup() {
    const { showSuccess, showError } = useToast();
    
    return {
      showSuccess,
      showError
    };
  },

  data: () => ({ 
    profile_information: {},
    company_information: {},
    biometrics_verification: {},
    company_verification: null,
    user_id: null,
    current_tab: 'Profile',
    tabs: [
      { label: 'Profile', value: 'Profile' },
      { label: 'Audit Trail', value: 'AuditTrail' }
    ],
    checks: {
      facial_biometrics: true,
      id_match: false,
      company_verification: true
  },
    name: '',
    email: '',
    phone_number: '',
    cipcReport: null,
    idvReport: null,
    cipcDirectorsPage: 1,
    cipcDirectorsPerPage: 5,
    customer_image: null,
    openSection: 'cipc',
    cipcChangeHistoryPage: 1,
    cipcChangeHistoryPerPage: 5,
    principalDropdowns: [],
  // Audit trail UI state
  audit_trails: [],
  audit_trail_count: 0,
  showConsentModal: false,
  modalContent: null,
  selectedAuditTrail: null,
  loadingConsentContent: false,
   }),
  computed: {
    // Normalized CIPC business info
    cipcBusinessInfo() {
      const info = this.cipcReport?.CommercialBusinessInformation || this.cipcReport?.CommercialCompanyInformation || {};
      return {
        registrationDate: info.RegistrationDate || 'N/A',
        businessStartDate: info.BusinessStartDate || 'N/A',
        financialYearEnd: info.FinancialYearEnd || 'N/A',
        sic: info.SIC || 'N/A',
        vatNo: info.VATNo || 'N/A',
        authorisedShares: info.AuthorisedNoOfShares || 'N/A',
        issuedShares: info.IssuedNoOfShares || 'N/A',
        directorCount: info.DirectorCount || '0',
        companyName: info.CommercialName || 'N/A',
        registrationNo: info.RegistrationNo || 'N/A',
        reference: this.cipcReport?.SubscriberInputDetails?.Reference || info.ReferenceNo || 'N/A'
      };
    },
    // Normalized CIPC directors
    cipcDirectorsList() {
      // Handles both array and single object for CommercialDirectorInformation
      const dir = this.cipcReport?.CommercialDirectorInformation;
      if (!dir) return [];
      const directors = Array.isArray(dir) ? dir : [dir];
      return directors.map(d => ({
        fullName: d.FullName || d.Fullname || [d.FirstName, d.Surname].filter(Boolean).join(' '),
        idNo: d.IDNo || 'N/A',
        status: d.DirectorStatusCode || 'N/A',
        appointmentDate: d.AppointmentDate || 'N/A'
      }));
    },
    cipcDirectorsTotalPages() {
      return Math.ceil(this.cipcDirectorsList.length / this.cipcDirectorsPerPage) || 1;
    },
    cipcDirectorsPaginated() {
      const start = (this.cipcDirectorsPage - 1) * this.cipcDirectorsPerPage;
      return this.cipcDirectorsList.slice(start, start + this.cipcDirectorsPerPage);
    },
    // Normalized CIPC addresses
    cipcAddresses() {
      const addresses = this.cipcReport?.CommercialAddressInformation;
      if (!addresses) return [];
      return Array.isArray(addresses) ? addresses : [addresses];
    },
    // Principal Directors (historical/principal info)
    cipcPrincipalDirectors() {
      // Handles both array and single object for CommercialPrincipalInformation
      const principalArr = this.cipcReport?.CommercialPrincipalInformation;
      if (!principalArr) return [];
      return Array.isArray(principalArr) ? principalArr : [principalArr];
    },
    // Change History
    cipcChangeHistory() {
      const arr = this.cipcReport?.ChangeHistoryInformation;
      if (!arr) return [];
      return Array.isArray(arr) ? arr : [arr];
    },
    // Normalized IDV info
    idvInfo() {
      const d = this.idvReport || {};
      return {
        fullName: [d.FirstName, d.LastName].filter(Boolean).join(' '),
        idNumber: d.IdNumber || 'N/A',
        maritalStatus: d.MaritalStatus || 'N/A',
        birthPlace: d.BirthPlaceCountry || 'N/A',
        idIssueDate: d.IDIssueDate || 'N/A',
        smartCardIssued: d.SmartCardIssued ? 'Issued' : 'Not Issued',
        facialImage: d.FacialImage || null,
        trackingNumber: d.TrackingNumber || 'N/A',
        deadIndicator: d.DeadIndicator ? 'Yes' : 'No',
        idBlocked: d.IDBlocked ? 'Yes' : 'No',
        onHanis: d.OnHanis ? 'Yes' : 'No',
        onNpr: d.OnNPR ? 'Yes' : 'No',
        walletCreated: d.IsWalletCreated ? 'Yes' : 'No'
      };
    },
    // Normalized IDV results
    idvResults() {
      const d = this.idvReport || {};
      return {
        livenessStatus: d.LivenessResult?.LivenessPassResult ? 'Live' : 'Spoof',
        livenessMessage: d.LivenessResult?.LivenessMessage || 'N/A',
        livenessQuality: d.LivenessResult?.LivenessResultQuality ? (d.LivenessResult.LivenessResultQuality * 100).toFixed(1) : '0.0',
        livenessProbability: d.LivenessResult?.LivenessResultProbability ? (d.LivenessResult.LivenessResultProbability * 100).toFixed(1) : '0.0',
        livenessScore: d.LivenessResult?.LivenessResultScore || 0,
        faceMatch: d.FaceResult?.isIdentical ? 'Match' : 'No Match',
        faceConfidence: d.FaceResult?.confidence ? (d.FaceResult.confidence * 100).toFixed(1) : '0.0',
        firstNameResult: d.FirstNameResult || '0',
        lastNameResult: d.LastNameResult || '0',
        status: d.Status === 'Success' ? 'Verified' : 'Failed'
      };
    },
    cipcChangeHistoryTotalPages() {
      return Math.ceil(this.cipcChangeHistory.length / this.cipcChangeHistoryPerPage) || 1;
    },
    cipcChangeHistoryPaginated() {
      const start = (this.cipcChangeHistoryPage - 1) * this.cipcChangeHistoryPerPage;
      return this.cipcChangeHistory.slice(start, start + this.cipcChangeHistoryPerPage);
    },
    isFallbackMode() {
      return (
        (!this.api_responses || !Array.isArray(this.api_responses) || !this.api_responses.length) &&
        (Object.keys(this.profile_information || {}).length > 0 || Object.keys(this.company_information || {}).length > 0)
      );
    },
  },
  watch: {
    cipcPrincipalDirectors: {
      immediate: true,
      handler(newVal) {
        // Ensure dropdown state array matches number of principals
        this.principalDropdowns = Array.isArray(newVal) ? newVal.map(() => false) : [];
      }
    }
  },
  methods: {
    fetch_application_data(user_id) {
      const TOKEN = localStorage.getItem('token');
      const VIEW_APPLICATION_API_URL = `${API_BASE_URL}/verify_api/verify_admin_api/view_user_application_api/${user_id}`;

      $.ajax({
        url: VIEW_APPLICATION_API_URL,
        method: 'GET',
        contentType: 'application/json',
        headers: {
            Authorization: `Token ${TOKEN}`
        },
        beforeSend: () => {
        this.loading = true;
        Swal.fire({
            text: 'Loading ...',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            }
        });
        },
        success: (response) => {
          this.profile_information = response.profile_information.length ? response.profile_information[0] : {};
          this.company_information = response.company_information.length ? response.company_information[0] : {};
          this.biometrics_verification = response.biometrics_verification
          this.company_verification = response.company_verification
          this.name = response.name
          this.phone_number = response.phone_number
          this.email = response.email
          this.checks = response.checks;
          this.api_responses = response.api_responses;
          this.customer_image = response.customer_image_base_64 || null;

          if (Array.isArray(response.audit_trails) && response.audit_trails.length) {
            this.audit_trails = response.audit_trails;
            this.audit_trail_count = response.audit_trail_count || response.count || this.audit_trails.length;
          }

          // Extract CIPC and IDV reports
          if (Array.isArray(response.api_responses) && response.api_responses.length) {
            // CIPC
            const cipc = response.api_responses.find(
              r => r.service_id__service_name && r.service_id__service_name.includes('CIPC')
            );
            this.cipcReport = cipc?.response?.full_response?.Commercial || null;

            // IDV
            const idv = response.api_responses.find(
              r => r.service_id__service_name && r.service_id__service_name.includes('ID Verification')
            );
            this.idvReport = idv?.response?.response || null;
          } else {
            // CIPC fallback
            if (this.company_information && Object.keys(this.company_information).length) {
              this.cipcReport = {
                CommercialBusinessInformation: {
                  CommercialName: this.company_information.company_name || 'N/A',
                  RegistrationNo: this.company_information.company_reg_no || 'N/A',
                },
                CommercialAddressInformation: [{
                  AddressLine1: this.company_information.company_address || 'N/A'
                }]
              };
            } else {
              this.cipcReport = null;
            }
            // IDV fallback
            if (this.profile_information && Object.keys(this.profile_information).length) {
              this.idvReport = {
                IdNumber: this.profile_information.id_number || 'N/A',
                FirstName: this.name || '',
                LastName: '',
              };
            } else {
              this.idvReport = null;
            }
          }
          Swal.close();
        },
        error: () => {
          Swal.close(); // Close the loading dialog on error
          this.showError('Failed to load application data. Please try again later.');
          this.loading = false; // Reset loading state
        }
      });
    },
    // Audit trail helpers (mirrors customer_data behaviour)
    shouldShowSuccessIcon(audit_trail) {
      const status = (audit_trail.status || '').toLowerCase();
      const activityLower = (audit_trail.activity || '').toLowerCase();

      if (status === 'success') {
        if (activityLower.includes('declined')) {
          return false;
        }
        return true;
      }

      return false;
    },

    shouldShowErrorIcon(audit_trail) {
      const status = (audit_trail.status || '').toLowerCase();
      const activityLower = (audit_trail.activity || '').toLowerCase();

      if (status === 'error') {
        return true;
      }

      if (activityLower.includes('declined')) {
        return true;
      }

      return false;
    },

    hasConsentContent(activity) {
      if (!activity) return false;
      const consentActivities = [
        'Indemnity Notice',
        'Marketing Consent',
        'Terms and Conditions'
      ];
      return consentActivities.some(consActivity =>
        activity.toLowerCase().includes(consActivity.toLowerCase())
      );
    },

    shouldShowConsentLink(activity) {
      if (!this.hasConsentContent(activity)) {
        return false;
      }

      const activityLower = activity.toLowerCase();

      if (activityLower.includes('indemnity')) return true;
      if (activityLower.includes('marketing')) return activityLower.includes('accepted');

      return (
        activityLower.includes('accepted') ||
        activityLower.includes('agreed to terms and conditions')
      );
    },

    fetchAndShowConsentContent(auditTrail) {
      this.loadingConsentContent = true;
      this.selectedAuditTrail = auditTrail;

      const token = localStorage.getItem("token");
      const base_url = API_BASE_URL;
      // Special-case: if the activity indicates Terms and Conditions were agreed,
      // fetch the customer terms URL and render an iframe or fallback template.
      if (auditTrail.activity && auditTrail.activity.toLowerCase().includes('agreed to terms and conditions')) {
        const terms_url = `${base_url}/verify_api/system_management_api/get_global_terms_and_conditions/`;

        $.ajax({
          method: 'GET',
          url: terms_url,
          headers: { Authorization: `Token ${token}` },
          success: (response) => {
            let content = '';

            if (response.status === 'terms_and_conditions_available') {
              content = TERMS_CONDITIONS_TEMPLATE;
            }

            this.modalContent = {
              content: content,
              consent_type: 'Terms and Conditions',
              auditInfo: {
                activity: auditTrail.activity,
                date: auditTrail.date_created,
                status: auditTrail.status,
                customer: 'Customer'
              }
            };

            this.showConsentModal = true;
            this.loadingConsentContent = false;
          },
          error: () => {
            this.showError('Error Getting Terms and Conditions');
            this.loadingConsentContent = false;
          }
        });

        return;
      }

      const consent_content_url = `${base_url}/verify_api/workflow_management_api/get_consent_content/${auditTrail.id}/`;

      $.ajax({
        method: "GET",
        url: consent_content_url,
        contentType: "application/json",
        dataType: "json",
        headers: {
          Authorization: `Token ${token}`
        },
        success: (data) => {
          this.modalContent = {
            content: data.consent_content || '<p>No content available</p>',
            consent_type: data.consent_type || "Consent Content",
            auditInfo: {
              activity: auditTrail.activity,
              date: auditTrail.date_created,
              status: auditTrail.status,
              customer: data.customer_name || "N/A"
            }
          };

          this.showConsentModal = true;
          this.loadingConsentContent = false;
        },
        error: (error) => {
          let error_message = 'Error Getting Consent Content';
          try {
            if (error.responseJSON?.error) error_message = error.responseJSON.error;
          } catch (e) {
            // ignore
          }
          if (error_message.includes('No consent content found') && auditTrail.activity && auditTrail.activity.toLowerCase().includes('terms and conditions')) {
            this.modalContent = {
              content: TERMS_CONDITIONS_TEMPLATE,
              consent_type: 'Terms and Conditions',
              auditInfo: {
                activity: auditTrail.activity,
                date: auditTrail.date_created,
                status: auditTrail.status,
                customer: 'Customer'
              }
            };
            this.showConsentModal = true;
            this.loadingConsentContent = false;
            return;
          }
          this.showError(error_message);

          this.loadingConsentContent = false;
        }
      });
    },

    // Save terms and conditions on behalf of a customer (client admin action)
    save_terms_and_conditions_for_admin(auditTrail, is_confirmed = true) {
      // Determine workflow id: try store getter, then route params, then profile info
      const workflow_id = this.$store?.getters?.get_workflow_id || this.$route?.params?.application || this.profile_information?.workflow_id;
      if (!workflow_id) {
        this.showError('Missing workflow id; cannot save terms.');
        return;
      }

      const TOKEN = localStorage.getItem('token');
      const CONSENT_URL = `${API_BASE_URL}/verify_api/customer_management_api/save_customer_terms_and_conditions/`;
      const FORM_DATA = {
        is_confirmed: is_confirmed,
        workflow_id: workflow_id
      };

      $.ajax({
        url: CONSENT_URL,
        method: 'POST',
        contentType: 'application/json',
        headers: { Authorization: `Token ${TOKEN}` },
        data: JSON.stringify(FORM_DATA),
        beforeSend: () => {
          Swal.fire({
            text: 'Saving ...',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => { Swal.showLoading(); }
          });
        },
        success: (response) => {
          Swal.close();
          if (response.status) {
            const status = String(response.status).toLowerCase();
            if (status === 'success' && is_confirmed === true) {
              this.showSuccess('Terms and conditions accepted.');
              // Refresh audit trails to reflect the newly created audit entry
              if (this.user_id) this.get_client_admin_audit_trail(this.user_id);
              this.fetch_application_data(this.user_id);
            } else if (status === 'success' && is_confirmed === false) {
              this.showSuccess('Terms declined.');
            }
          }
        },
        error: (xhr) => {
          Swal.close();
          this.showError(xhr.responseJSON?.error || 'Error while providing consent');
        }
      });
    },

    closeModal() {
      this.showConsentModal = false;
      this.modalContent = null;
      this.selectedAuditTrail = null;
    },

    formatDateTime(date) {
      if (!date) return "N/A";
      const d = new Date(date);
      if (isNaN(d.getTime())) return "N/A";
      return d.toLocaleString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false
      });
    },

    get_client_admin_audit_trail(client_admin_id) {
      const token = localStorage.getItem('token');
      const base_url = API_BASE_URL;
      if (!client_admin_id) return;

      const url = `${base_url}/verify_api/verify_admin_api/client_admin_audit_trail/${client_admin_id}/`;

      $.ajax({
        method: 'GET',
        url: url,
        contentType: 'application/json',
        dataType: 'json',
        headers: { Authorization: `Token ${token}` },
        success: (response) => {

          let results = null;

          if (Array.isArray(response.results)) {
            results = response.results;
          } else if (response && response.data && Array.isArray(response.data.results)) {
            results = response.data.results;
          } else if (Array.isArray(response.audit_trails)) {
            results = response.audit_trails;
          } else if (response && response.data && Array.isArray(response.data.audit_trails)) {
            results = response.data.audit_trails;
          } else if (Array.isArray(response)) {
            results = response;
          } else if (response && typeof response === 'object') {
            // Last resort: look for any array-valued property that looks like entries
            for (const key in response) {
              if (Array.isArray(response[key]) && response[key].length > 0) {
                results = response[key];
                break;
              }
            }
          }

          this.audit_trails = Array.isArray(results) ? results : [];
          this.audit_trail_count = response.count || response.audit_trail_count || (response.data && response.data.count) || this.audit_trails.length;
        },
        error: (xhr) => {
          console.error('Error fetching client admin audit trail:', xhr);
        }
      });
    },
    setCipcDirectorsPage(page) {
      if (page >= 1 && page <= this.cipcDirectorsTotalPages) {
        this.cipcDirectorsPage = page;
      }
    },
    setCipcChangeHistoryPage(page) {
      if (page >= 1 && page <= this.cipcChangeHistoryTotalPages) {
        this.cipcChangeHistoryPage = page;
      }
    },
    toggleCipcSection() {
      this.openSection = this.openSection === 'cipc' ? null : 'cipc';
    },
    toggleIdvSection() {
      this.openSection = this.openSection === 'idv' ? null : 'idv';
    },
  },
  mounted() {
    if (!validateToken(this.$router)) {
      return;
  }
    const user_id = this.user_id || this.$route.params.user_id;
    this.user_id = user_id;
    this.fetch_application_data(user_id);
    if (user_id) {
      this.get_client_admin_audit_trail(user_id);
    }
  }
};
